var $4a4c220cbaf33119$exports = {};
$4a4c220cbaf33119$exports = {
    "clear": `Effacer`,
    "invalid": `(non valide)`,
    "loading": `Chargement en cours...`,
    "noResults": `Aucun r\xe9sultat`
};


export {$4a4c220cbaf33119$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
